const constants = {
    WISHLIST:'Wishlist'
}
export default constants;